// Module
var code = "<div class=\"row\"> {{{items}}} </div>";
// Exports
export default code;